"use client";

import Link from "next/link";
import AppImage from "@/components/ui/AppImage";
import { useEffect, useRef, useState } from "react";
import CountUp from "@/components/ui/CountUp";

export default function HeroSection() {
    return (
        <section
            className="relative flex items-end"
            style={{ minHeight: "100vh", paddingTop: "68px" }}
            aria-label="Hero">

            {/* Background Image */}
            <div className="absolute inset-0 z-0">
                <AppImage
                    src="https://images.unsplash.com/photo-1697869152608-bc9132309181"
                    alt="Industrial refinery at dusk — steel towers and processing infrastructure"
                    fill
                    className="object-cover"
                    priority />

                {/* Navy overlay with gradient */}
                <div
                    className="hero-overlay absolute inset-0"
                    style={{
                        background:
                            "linear-gradient(160deg, rgba(14,26,43,0.92) 0%, rgba(14,26,43,0.78) 45%, rgba(14,26,43,0.65) 100%)"
                    }} />

                {/* Bottom fade to surface */}
                <div
                    className="absolute bottom-0 left-0 right-0"
                    style={{
                        height: "200px",
                        background:
                            "linear-gradient(to bottom, transparent, rgba(14,26,43,0.4))"
                    }} />

            </div>
            {/* Content */}
            <div
                className="relative z-10 w-full px-6 lg:px-12 pb-20 lg:pb-28"
                style={{ maxWidth: "1280px", margin: "0 auto" }}>

                <div className="max-w-3xl">
                    {/* Eyebrow */}
                    <div className="animate-hero-1 flex items-center gap-3 mb-8">
                        <span
                            className="divider-red"
                            style={{ width: "32px" }}
                            aria-hidden="true" />

                        <span className="type-subheading" style={{ color: "var(--color-red)" }}>
                            Strategic Antimony Supply
                        </span>
                    </div>

                    {/* Headline */}
                    <h1 className="type-display animate-hero-2" style={{ marginBottom: "28px" }}>
                        Reliable Antimony Supply
                        <br />
                        for Global Refiners.
                    </h1>

                    {/* Subheadline */}
                    <p
                        className="animate-hero-3"
                        style={{
                            fontFamily: "var(--font-sans)",
                            fontSize: "1.0625rem",
                            color: "rgba(255,255,255,0.72)",
                            lineHeight: "1.7",
                            maxWidth: "560px",
                            marginBottom: "40px"
                        }}>

                        Secure long-term feed with transparent commercial terms,
                        logistics-ready delivery, and responsible sourcing.
                    </p>

                    {/* CTAs */}
                    <div className="animate-hero-4 flex flex-wrap gap-4">
                        <Link href="/contact" className="btn-primary">
                            Request Proposal
                            <svg
                                width="14"
                                height="14"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth="2.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                aria-hidden="true">

                                <path d="M5 12h14M12 5l7 7-7 7" />
                            </svg>
                        </Link>
                        <button
                            className="btn-secondary"
                            onClick={() => {
                                // Mock download — in production connects to file endpoint
                                alert("Corporate Overview PDF — download endpoint: GET /api/downloads/corporate-overview");
                            }}>

                            <svg
                                width="14"
                                height="14"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth="2.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                aria-hidden="true">

                                <path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4M7 10l5 5 5-5M12 15V3" />
                            </svg>
                            Download Corporate Overview
                        </button>
                    </div>
                </div>

                {/* Bottom stat bar */}
                <div
                className="mt-16 pt-10 grid grid-cols-2 md:grid-cols-4 gap-8"
                style={{ borderTop: "1px solid rgba(255,255,255,0.12)" }}
                >
                {[
                    { value: 18000, label: "Contracted Supply Capacity", suffix: " t/yr" },
                    { value: 14, label: "Active Refinery Partners" },
                    { value: 99.4, label: "On-Time Delivery Performance", suffix: "%", decimals: 1 },
                    { value: "ISO 14001", label: "Environmental Certification" },
                ].map((s) => (
                    <div key={s.label}>
                    <p
                        style={{
                        fontFamily: "var(--font-serif)",
                        fontSize: "1.5rem",
                        color: "var(--color-white)",
                        lineHeight: 1,
                        marginBottom: "6px",
                        }}
                    >
                        {typeof s.value === "number" ? (
                        <CountUp
                            end={s.value}
                            suffix={s.suffix}
                            decimals={s.decimals}
                        />
                        ) : (
                        s.value
                        )}
                    </p>

                    <p
                        style={{
                        fontFamily: "var(--font-sans)",
                        fontSize: "0.75rem",
                        color: "rgba(255,255,255,0.45)",
                        letterSpacing: "0.04em",
                        }}
                    >
                        {s.label}
                    </p>
                    </div>
                ))}
                </div>
            </div>
        </section>);

}